import {useMutation} from "@tanstack/react-query";

import {restoreMaterialMutationOptions} from "./restore-material.mutation-options";

export function useRestoreMaterial() {
  return useMutation(restoreMaterialMutationOptions());
}
